<template>
	<img class="logo" src="/storage/images/Sertus Logo.svg" alt="Black sertus logo" />
</template>
